const pendingKey = 'ninacheck.admin-entry';
const pagePattern = /^\/(?:index|cod|exchange-rates|online(?:\/(?:payment-integration|checkout-settings|upsell))?|integrations(?:\/(?:pixels|email-marketing|google-sheets|traffic-protection|google-maps))?|administration)?$/;

// Store only the intended page, never authentication tokens. A direct sidebar
// load can start a new document without the application's in-memory token.
export function prepareAdminEntry({ location, token, apiDomain, storage, now = Date.now() }) {
  const params = new URLSearchParams(location.search);
  const shop = params.get('shop') || params.get('shop_domain');
  if (token) {
    let pending;
    try {
      pending = JSON.parse(storage?.getItem(pendingKey) || 'null');
      storage?.removeItem(pendingKey);
    } catch (_) { /* Storage is optional in embedded browsers. */ }
    if (pending && pending.shop === shop && pagePattern.test(pending.path) &&
        now >= pending.at && now - pending.at < 10 * 60 * 1000) {
      if (pending.tab) params.set('tab', pending.tab);
      return { restore: pending.path + '?' + params.toString() };
    }
    return {};
  }
  if (!shop) return {};
  if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop)) {
    throw new Error('Invalid shop. Reopen NinaCheck from Shopify admin.');
  }
  const auth = new URL('/api/auth', apiDomain);
  if (!['https:', 'http:'].includes(auth.protocol)) throw new Error('The authentication server is not configured.');
  // Keep the original Shopify launch query intact, including signed parameters.
  auth.search = location.search;
  if (!params.has('shop')) auth.searchParams.set('shop', shop);
  try {
    storage?.setItem(pendingKey, JSON.stringify({
      shop, path: pagePattern.test(location.pathname) ? location.pathname : '/index',
      tab: params.get('tab'), at: now,
    }));
  } catch (_) { /* Without storage, authentication returns to the dashboard. */ }
  return { redirect: auth.href };
}
